import React from "react";
import "./Home.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";

import { Autoplay } from "swiper/modules";
import { FaStar } from "react-icons/fa";

const testimonials = [
  {
    name: "Amit Sharma",
    role: "Startup Founder",
    review:
      "They built our SaaS product with AI automation. Our revenue increased 3X!",
  },
  {
    name: "Neha Verma",
    role: "E-commerce Owner",
    review:
      "Our conversion rate improved drastically after their funnel system.",
  },
  {
    name: "Rahul Mehta",
    role: "Real Estate Consultant",
    review:
      "CRM + automation they built changed our entire workflow.",
  },
  {
    name: "Priya Singh",
    role: "Founder",
    review:
      "Amazing AI-based LMS platform. Highly recommend!",
  },
];

const Testimonial = () => {
  return (
    <section className="backdiv">
      <h2 className="main-title">Testimonials</h2>

      <Swiper
        modules={[ Autoplay]}
        spaceBetween={30}
        loop={true}
        autoplay={{ delay: 2500 }}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="testimonial-swiper"
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial-card">
                <div>
              <p className="main-text-white">“{item.review}”</p>

              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>

              <div className="user">
                <div>
                  <h4>{item.name}</h4>
                  <span>{item.role}</span>
                </div>
              </div>
            </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonial;